import { useTranslations } from "next-intl";
import * as dc from "@/components/layout/list/defaultType";
import { DataInputParams, PickerType } from "./inputType";
import { Form, Skeleton as AntSkeleton, ConfigProvider, Button, Tooltip, Flex } from "antd";
import { Debug } from "@/util/debug";
import {
  checkDisabled,
  checkNoItem,
  GetDataInputElement,
  getDatePicker,
  getDayjs,
  getDayjsFirst,
  getDayjsStr,
  getDayjsValueStr,
  getMultiValue,
  getPlaceholder,
  getTooltip,
} from "./inputFunction";
import { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from "react";
import { TransitionType } from "@/components/layout/layoutType";
import dayjs, { Dayjs } from "dayjs";
import { arrPickObj, getStringArr } from "@/util/arrayutil";
import { PickerLocale } from "antd/es/date-picker/generatePicker";
import { cn } from "@/lib/utils";

import Icon from "@/components/common/icon/icon";
// import dynamic from "next/dynamic";
// const Icon = dynamic(() => import("@/components/common/icon/icon"), { ssr: false });

import { DatePicker, TimePicker } from "antd";
import { disableScroll, enableScroll } from "@/util/checkMobile";
import { appInputScroll, isNativePlatform } from "@/util/apputil";
// const DatePicker = dynamic(() => import("antd").then((mod) => mod.DatePicker), { ssr: false });
// const TimePicker = dynamic(() => import("antd").then((mod) => mod.TimePicker), { ssr: false });
// const DatePickerRange = dynamic(() => import("antd").then((mod) => mod.DatePicker.RangePicker), { ssr: false });
// const TimePickerRange = dynamic(() => import("antd").then((mod) => mod.TimePicker.RangePicker), { ssr: false });

const getFormatStr = (pickerType: PickerType, dateTimeFormat?: PickerLocale) => {
  if (dateTimeFormat) {
    switch (pickerType.mode) {
      case "month":
        return dateTimeFormat?.monthFormat;
      case "week":
        return dateTimeFormat?.weekFormat;
      case "time":
        return "HH:mm:ss";
      case "date":
      default:
        if (pickerType.showTime) {
          return dateTimeFormat?.dateTimeFormat;
        } else {
          return dateTimeFormat?.dateFormat;
        }
    }
  } else {
    return undefined;
  }
};
const getTimerValue = (value: Dayjs, params: DataInputParams) => {
  if (value === undefined || value === null) {
    return undefined;
  }
  const offset = dayjs().utcOffset();
  if (value instanceof Array) {
    let change = false;
    const arr = value.map((a) => {
      let result = dayjs.utc(0);
      if (params.timeProp?.showHour ?? true) {
        result = result.set("hour", a.hour());
      }
      if (params.timeProp?.showMinute ?? true) {
        result = result.set("minute", a.minute());
      }
      if (params.timeProp?.showSecond ?? true) {
        result = result.set("second", a.second());
      }
      if (params.timeProp?.showMillisecond) {
        result = result.set("millisecond", a.millisecond());
      }
      result = result.add(-offset, "minute");
      if (!a.isSame(result)) {
        change = true;
      }
      return result;
    });
    // if (change) {
    //   return arr;
    // } else {
    //   return undefined;
    // }
    return arr;
  } else {
    let result: Dayjs = dayjs(0);
    if (params.timeProp?.showHour ?? true) {
      result = result.set("hour", value.hour());
    }
    if (params.timeProp?.showMinute ?? true) {
      result = result.set("minute", value.minute());
    }
    if (params.timeProp?.showSecond ?? true) {
      result = result.set("second", value.second());
    }
    if (params.timeProp?.showMillisecond) {
      //Debug("setm");
      result = result.set("millisecond", value.millisecond());
    }
    result = result.add(-offset, "minute");
    //Debug(value.valueOf(), result.valueOf());
    // if (value.isSame(result)) {
    //   return undefined;
    // } else {
    //   return result;
    // }
    return result;
  }
};
const GetInput = (
  t: TransitionType,
  setTooltip: Dispatch<SetStateAction<string | undefined>>,
  params: DataInputParams,
  pickerType: PickerType,
  //dateTimeFormat?: PickerLocale,
  dateFormatter?: string,
  disabled?: boolean,
  now?: number,
) => {
  const pickerRef = useRef<any>(null);

  //const fieldList = getStringArr(params.fieldList);
  const values = getMultiValue(params, params.value);
  // Debug(params.name, values);
  const valueDate = values
    ? getDayjs(pickerType.timePicker && typeof params.value === "number" ? Math.abs(values) : values, params.inputType)
    : undefined;
  const defaultDate =
    params.defaultValue !== undefined && params.defaultValue !== null ? getDayjs(params.defaultValue, params.inputType) : undefined;
  //const dateFormatter = params.dateFormatter ?? getFormatStr(pickerType, dateTimeFormat);

  const placeholder = now
    ? getDayjsValueStr(dayjs(now), params.inputType, true, dateFormatter) + ""
    : (getPlaceholder(t, params, disabled) ?? getDayjsStr(defaultDate, dateFormatter) ?? getDayjsStr(valueDate, dateFormatter));

  const value = params.inputMode === "view" && !(params.readInputDisabled ?? false) ? (valueDate ?? null) : null;
  const inputReadOnly = params.readOnly === undefined ? params.inputMode == "view" : params.readOnly;
  const PickerProp = pickerType.timePicker
    ? { ...params.timeProp, format: dateFormatter, inputReadOnly: inputReadOnly }
    : { ...params.dateProp, format: dateFormatter, inputReadOnly: inputReadOnly, picker: pickerType.picker };
  const [secondBlock, setSecondBlock] = useState<boolean>(params.value ? false : true);

  //Debug(params.name, values, valueDate);
  // Debug("DatePicker : " + params.name, params, value, valueDate, values);

  if (pickerType.range) {
    // Debug("dateRange", params.name, values);
    const Picker = pickerType.timePicker ? TimePicker.RangePicker : DatePicker.RangePicker;
    const firstValueDate = params.value ? getDayjsFirst(getMultiValue(params, params.value)) : undefined;
    const rangeValueDate = params.rangeValue ? getDayjsFirst(params.rangeValue) : undefined;
    const rangeDefaultDate = params.rangeDefaultValue ? getDayjsFirst(params.rangeDefaultValue) : undefined;
    const rangePlaceholder =
      (params.rangePlaceholder ?? params.inputMode == "view")
        ? ""
        : (getDayjsStr(rangeDefaultDate, dateFormatter) ?? getDayjsStr(rangeValueDate, dateFormatter));
    return (
      <Picker
        ref={pickerRef}
        className={cn(params.inputClassName, params.hiddenCheckValue ? "item-hidden-check" : "", now ? "now-check" : "")}
        variant={params.variant ?? (params.inputMode === "view" ? dc.viewVariant : undefined)}
        placeholder={placeholder || rangePlaceholder ? [placeholder ?? "", rangePlaceholder ?? ""] : undefined}
        value={[firstValueDate, rangeValueDate]}
        disabled={disabled}
        id={params.id}
        name={params.name}
        showTime={pickerType.showTime}
        mode={[pickerType.mode ?? "date", pickerType.mode ?? "date"]}
        allowEmpty={disabled}
        onChange={params.onChange}
        {...PickerProp}
        onOpenChange={(e) => {
          appInputScroll(pickerRef, e, false, true, params.scrollMargin);
          if (PickerProp?.onOpenChange) {
            PickerProp.onOpenChange(e);
          }
        }}
      />
    );
  } else {
    if (pickerType.timePicker) {
      const onChangeTime = (value: Dayjs, str: string | string[]) => {
        const form = params.form;
        const result = getTimerValue(value, params);
        const formValue = form && params.name ? form.getFieldValue(params.name) : undefined;
        if (result === undefined) {
          if (value === null || undefined) {
            if (form && params.name) {
              if (formValue !== undefined) {
                const setValue: Record<string, any> = {};
                setValue[params.name] = undefined;
                form.setFieldsValue(setValue);
              }
            }
            if (params.onChange) {
              params.onChange({ key: params.name, value: value, index: params.index });
            }
          }
        } else {
          if (form && params.name) {
            if (result !== formValue) {
              const setValue: Record<string, any> = {};
              setValue[params.name] = result;
              form.setFieldsValue(setValue);
            }
          }
          if (params.onChange) {
            params.onChange({ key: params.name, value: result, index: params.index });
          }
        }
      };
      return (
        <TimePicker
          ref={pickerRef}
          className={cn(params.inputClassName, params.hiddenCheckValue ? "item-hidden-check" : "", now ? "now-check" : "")}
          variant={params.variant ?? (params.inputMode === "view" ? dc.viewVariant : undefined)}
          placeholder={placeholder}
          value={arrPickObj(value)}
          disabled={disabled}
          id={params.id}
          name={params.name}
          mode={pickerType.mode}
          // suffixIcon={params.readOnly || disabled ? "" : undefined}
          onChange={onChangeTime}
          {...PickerProp}
          secondStep={PickerProp.secondStep ?? (secondBlock ? 10 : 1)}
          onCalendarChange={
            PickerProp.secondStep !== undefined
              ? undefined
              : (val) => {
                  if (val !== undefined && !(val instanceof Array)) {
                    const sec = val.second();
                    if (sec % 10 === 0) {
                      // 10초 단위 선택 시 → input은 그대로, 블록만 활성화
                      setSecondBlock((prev) => !prev);
                    } else {
                      // 블록 내 1초 단위 선택 시 → input 업데이트
                      setSecondBlock(false); // 완료 후 초기화
                    }
                  }
                }
          }
          // onSelect={(val) => {
          //   const sec = val.second();

          //   if (sec % 10 === 0) {
          //     // 10초 단위 선택 시 → input은 그대로, 블록만 활성화
          //     setSecondBlock(sec);
          //   } else {
          //     // 블록 내 1초 단위 선택 시 → input 업데이트
          //     setValue(val);
          //     setSecondBlock(null); // 완료 후 초기화
          //   }
          // }}
          onOpenChange={(e) => {
            appInputScroll(pickerRef, e, false, true, params.scrollMargin);
            if (PickerProp?.onOpenChange) {
              PickerProp.onOpenChange(e);
            }
          }}
        />
      );
    } else {
      const onChange = (value: unknown, str: string | string[]) => {
        if (!(value instanceof Array)) {
          const value_day = value as Dayjs;
          setTooltip(value ? getDayjsValueStr(value_day, params.inputType, true, dateFormatter) + "" : undefined);
        } else {
          setTooltip(undefined);
        }
        if (params.onChange) {
          params.onChange({ key: params.name, value: value, index: params.index });
        }
      };
      //return undefined;
      return (
        <DatePicker
          ref={pickerRef}
          className={cn(params.inputClassName, params.hiddenCheckValue ? "item-hidden-check" : "", now ? "now-check" : "")}
          variant={params.variant ?? (params.inputMode === "view" ? dc.viewVariant : undefined)}
          placeholder={placeholder}
          multiple={pickerType.multiple}
          maxTagCount="responsive"
          disabled={disabled}
          id={params.id}
          name={params.name}
          showTime={pickerType.showTime}
          mode={pickerType.mode}
          // suffixIcon={params.readOnly || disabled ? "" : undefined}
          {...PickerProp}
          value={value}
          onChange={onChange}
          onOpenChange={(e) => {
            appInputScroll(pickerRef, e, false, true, params.scrollMargin);
            if (PickerProp?.onOpenChange) {
              PickerProp.onOpenChange(e);
            }
          }}
        />
      );
    }
  }
};

export default function DataInput(params: DataInputParams) {
  const t = useTranslations(params.transitionGroup ?? "contents");
  const prev = params.prev ? GetDataInputElement(params.prev, false, params.values, t) : undefined;
  const next = params.next ? GetDataInputElement(params.next, true, params.values, t) : undefined;
  const unitPrev = params.unitPrev ? GetDataInputElement(params.unitPrev, false, params.values, t) : undefined;
  const unit = params.unit ? GetDataInputElement(params.unit, true, params.values, t) : undefined;
  const pickerType = getDatePicker(params.inputType);
  const initialValue = getMultiValue(params, params.value ?? params.defaultValue);
  const initialDayjs = initialValue !== undefined && initialValue !== null ? getDayjs(initialValue, params.inputType) : undefined;
  // Debug(params.name, initialValue, initialDayjs, params, params.value, params.defaultValue);
  const antdContextDateTimeFormat = useContext(ConfigProvider.ConfigContext).locale?.DatePicker;
  const disabled = checkDisabled(params);
  const [now, setNow] = useState<number | undefined>(undefined);
  const dateFormatter =
    typeof params.dateFormatter === "string" ? params.dateFormatter : getFormatStr(pickerType, antdContextDateTimeFormat);

  const setNowClick = () => {
    let changeValue = undefined;
    const isSetNow = typeof params.indexKey === "string" && params.indexKey !== params.name;
    const setValues: Record<string, any> = {};
    if (isSetNow) {
      if (params.form) {
        const baseTime = params.form.getFieldValue(params.indexKey);
        if (baseTime !== undefined && baseTime !== null) {
          const inputTime = params.form.getFieldValue(params.name);
          const diffTime = Math.abs((inputTime === undefined && now !== undefined ? now : new Date().getTime()) - baseTime);
          // Debug(params.indexKey, params.name, baseTime, diffTime);
          changeValue = dayjs(diffTime);
        } else {
          // Debug(params.indexKey, params.name, baseTime);
        }
      }
    } else {
      changeValue = dayjs(new Date());
      const basetime = dayjs(changeValue);
      if (typeof params.indexKey === "string" && params.indexKey === params.name && params.formMemo) {
        Object.keys(params.formMemo).forEach((key) => {
          if (params.form && params.formMemo && params.formMemo[key].now) {
            setValues[key] = dayjs(Math.abs(dayjs(params.formMemo[key].now).valueOf() - basetime.valueOf())).add(
              -dayjs().utcOffset(),
              "minute",
            );
            params.form.setFieldValue(
              key,
              dayjs(Math.abs(dayjs(params.formMemo[key].now).valueOf() - basetime.valueOf())).add(-dayjs().utcOffset(), "minute"),
            );
          }
        });
      }
    }
    if (changeValue && pickerType.timePicker) {
      changeValue = changeValue.add(-dayjs().utcOffset(), "minute");
    }
    if (params.form && params.name) {
      setValues[params.name] = changeValue;
    }
    if (!pickerType.timePicker) {
      setTooltip(changeValue ? getDayjsValueStr(changeValue, params.inputType, true, dateFormatter) + "" : undefined);
    }
    if (Object.keys(setValues).length > 0 && params.form) {
      params.form.setFieldsValue(setValues);
    }

    if (isSetNow) {
      const now = new Date().getTime();
      setNow(now);
      if (params.formMemo && params.name) {
        params.formMemo[params.name] = { ...params.formMemo[params.name], now: now };
      }
    }
    if (params.dateProp?.nowButtonClick) {
      params.dateProp.nowButtonClick({ key: params.name, value: changeValue, index: params.index });
    }
    if (params.timeProp?.nowButtonClick) {
      params.timeProp.nowButtonClick({ key: params.name, value: changeValue, index: params.index });
    }
    if (params.onChange) {
      params.onChange({ key: params.name, value: changeValue, index: params.index });
    }
  };

  if (params.formFunction && params.name) {
    if (!params.formFunction[params.name]) {
      params.formFunction[params.name] = {};
    }
    params.formFunction[params.name]["setNow"] = (nowTime: any) => {
      const now = nowTime !== undefined ? dayjs(nowTime).valueOf() : undefined;
      if (params.formMemo && params.name) {
        if (!params.formMemo[params.name]) {
          params.formMemo[params.name] = {};
        }
        params.formMemo[params.name] = { ...params.formMemo[params.name], now: now };
      }
      setNow(now);
    };
    params.formFunction[params.name]["setNowClick"] = () => {
      setNowClick();
    };
  }

  useEffect(() => {
    if (params.formMemo && params.name) {
      if (!params.formMemo[params.name]) {
        params.formMemo[params.name] = {};
      }
      const temp_memo = params.formMemo[params.name];
      temp_memo.inputType = params.inputType;
      temp_memo.noItem = checkNoItem(params);

      temp_memo.subListTarget = params.subListTarget
        ? { target: params.subListTarget, name: params.subListName, index: params.index }
        : undefined;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.formMemo, params.name, params.inputType, params.inputMode, params.noItem, params.subListTarget]);

  const [tooltip, setTooltip] = useState(() => {
    return typeof params.tooltip !== "boolean"
      ? getTooltip(t, params)
      : params.tooltip && initialDayjs !== undefined
        ? getDayjsValueStr(initialDayjs, params.inputType, true, dateFormatter) + ""
        : undefined;
  });

  useEffect(() => {
    const temp_tooltip =
      typeof params.tooltip !== "boolean"
        ? getTooltip(t, params)
        : params.tooltip && initialDayjs !== undefined
          ? getDayjsValueStr(initialDayjs, params.inputType, true, dateFormatter) + ""
          : undefined;
    if (tooltip !== temp_tooltip) {
      setTooltip(temp_tooltip);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.tooltip, dateFormatter]);
  //Debug(tooltip, initialValue);
  //Debug(params);
  const nowButtonCheck = pickerType.timePicker
    ? (params.timeProp?.nowButton ?? params.dateProp?.nowButton)
    : (params.dateProp?.nowButton ?? params.timeProp?.nowButton);
  const NowButton = () => {
    if (
      ((params.inputMode !== "view" && (nowButtonCheck ?? true)) ||
        (params.inputMode === "view" && ((nowButtonCheck ?? false) || !(params.noItem ?? true)))) &&
      !pickerType.range &&
      !pickerType.multiple
    ) {
      //Debug(params.name, nowButtonCheck);
      return (
        <Button
          icon={<Icon iconName="ClockUser" iconType="" />}
          onClick={setNowClick}
          className={cn(
            params.dateProp?.nowButtonFront ? "mr-2" : "ml-2",
            disabled && !nowButtonCheck ? "invisible" : "",
            params.dateProp?.nowButtonClassName,
            params.timeProp?.nowButtonClassName,
            "with_pick my-auto",
          )}
          id={params.name + "_nowButton"}
          name={params.name + "_nowButton"}
        />
      );
    } else {
      return <></>;
    }
  };

  // Debug("DatePicker : " + params.name, params, initialDayjs);

  return (
    <Tooltip color={dc.tooltipColor} title={tooltip} placement={params.tooltipPlacement} {...params.tooltipProps}>
      <Flex>
        {prev}
        {params.dateProp?.nowButtonFront ? <NowButton /> : ""}
        {unitPrev}
        {checkNoItem(params) ? (
          GetInput(t, setTooltip, params, pickerType, dateFormatter, disabled, now)
        ) : (
          <Form.Item name={params.name} noStyle initialValue={initialDayjs} required={params.required}>
            {GetInput(t, setTooltip, params, pickerType, dateFormatter, disabled, now)}
          </Form.Item>
        )}
        {unit}
        {params.dateProp?.nowButtonFront ? "" : <NowButton />}
        {next}
      </Flex>
    </Tooltip>
  );
}
